export const links = {
  RGCamsMobile: "https://rgcams.com/landing/click/?AFNO=1-4",
  RGCamsDesktop: "https://rgcams.com/landing/click/?AFNO=1-11",
  RGAiDesktop: "https://redgifs.ai/?utm_source=redgifs.com&utm_medium=burger_menu&utm_campaign=launch&utm_content=desktop",
  RGAiMobile: "https://redgifs.ai/?utm_source=redgifs.com&utm_medium=burger_menu&utm_campaign=launch&utm_content=mobile",
};
